import { React, useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';

export default function Newtitles() {
 // const navigate = useNavigate();
    
  const [titles, setTitles] = useState([]);
  useEffect(() => {
    const fetchMessages = async () => {
      try {
        const res = await fetch(
          'https://nmt.loveworldapis.com/api/pcdl/lists/messages',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ id: 'newreleases' }),
          },
        );

        const data = await res.json();
        console.log(data); 

        setTitles(data.data || data);
      } catch (err) {
        console.error(err);
      }
    };
    fetchMessages();
  }, []);

  return (
    <div className="grid md:grid-cols-7 gap-9 ml-28   text-left px-3 py-1">
      {titles.map((item) => (
        <a 
          href={[`/watch/${item.id}`]} 
          target="_blank" 
          rel="noopener noreferrer"
          key={item.id}
          className="  h-[300px]  flex flex-col  justify-content   hover:shadow-lg "
        > 
        
          <img src={item.thumbnail} alt={item.title} className="h-30 w-full object-cover  mb-4" />
          <h3 className="font-semibold text-white">{item.title}</h3>
        </a>
        ))}
    </div>
  );
}
